import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";

import SoftBox from "components/SoftBox";
import { useAuth } from "context/AuthContext";
import NotAllowedPage from "layouts/not-allowed";

function AccessGuard({ children, resource }) {
  const { loading, isAuthenticated, hasAccess } = useAuth();

  if (loading) {
    return (
      <SoftBox
        minHeight="100vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <CircularProgress color="info" />
      </SoftBox>
    );
  }

  if (!isAuthenticated()) {
    return <Navigate to="/authentication/sign-in" replace />;
  }

  if (!hasAccess(resource)) {
    return <NotAllowedPage />;
  }

  return children;
}

AccessGuard.defaultProps = {
  resource: null,
};

AccessGuard.propTypes = {
  children: PropTypes.node.isRequired,
  resource: PropTypes.string,
};

export default AccessGuard;
